(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('TradePolicyRuleEffectDialogController', TradePolicyRuleEffectDialogController);

    TradePolicyRuleEffectDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'TradePolicyRuleEffect', 'TradePolicyRule', 'Product', 'PresentList'];

    function TradePolicyRuleEffectDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, TradePolicyRuleEffect, TradePolicyRule, Product, PresentList) {
        var vm = this;
        vm.tradePolicyRuleEffect = entity;
        vm.tradepolicyrules = TradePolicyRule.query();
        vm.products = Product.query();
        vm.presentlists = PresentList.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('sigmasfApp:tradePolicyRuleEffectUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.tradePolicyRuleEffect.id !== null) {
                TradePolicyRuleEffect.update(vm.tradePolicyRuleEffect, onSaveSuccess, onSaveError);
            } else {
                TradePolicyRuleEffect.save(vm.tradePolicyRuleEffect, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
